import { config } from './config';

declare const ga: UniversalAnalytics.ga | undefined;

export const getGa = () => {
  if (typeof ga === 'undefined') {
    return undefined;
  }
  return ga;
};

export const GaTrackingId = 'UA-82102317-3';

/**
 * Returns first GA tracker with clientId, preffering our tracking code
 * If no tracker is found, returns string explaning which case happened:
 * - `NO_GA` if global `ga` object is undefined or doesn't have getAll method
 * - `NO_GA_TRACKERS` if global `ga.getAll` method returns empty array
 * - `NO_GA_ID_FROM_TRACKERS` if all trackers from `ga.getAll` return no clientId
 */
export const getActiveTracker = () => {
  const ga = getGa();

  if (!ga || !ga.getAll) return 'NO_GA';

  const allTrackers = ga.getAll();
  if (!allTrackers.length) return 'NO_GA_TRACKERS';

  const tracker = allTrackers.reduce<UniversalAnalytics.Tracker | undefined>(
    (foundTracker, tracker) => {
      // Tracker has clientId
      if (tracker.get('clientId')) {
        // If no previous tracker was found, save the current one
        if (!foundTracker) return tracker;
        // If previous tracker was found, check if the current one has our preffered ID
        else if (tracker.get('trackingId') === GaTrackingId) return tracker;
      }

      return foundTracker;
    },
    undefined,
  );

  return tracker || 'NO_GA_ID_FROM_TRACKERS';
};

export const getGaClientId = () => {
  const tracker = getActiveTracker();

  if (typeof tracker === 'string') return tracker;

  return tracker.get('clientId') as string;
};

export const sendGAEvent = (
  category: string,
  action: string,
  label: string,
  value?: number,
) => {
  const tracker = getActiveTracker();
  if (typeof tracker !== 'string') {
    tracker.send('event', category, action, label, value);
  }

  // debug logging
  if (!config.GTM_ENABLED) {
    // eslint-disable-next-line
    console.debug('ga event send', { category, action, label, value });
  }
};
